// extracted by mini-css-extract-plugin
export default {"clrAvatar":"#8c8c8c","acronym":"Avatar_acronym__IZbPb"};